module.exports = __webpack_public_path__ + "static/media/New-Zealand.ace47f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/New-Zealand.jpg
// module id = 995
// module chunks = 0